<template>
    <div class="specialisms my-2" v-if="(typeof(tyre) != 'undefined')">
        <span
            v-for="badge, index in specialismBadges"
            class="badge bg-light-subtle px-2 p-lg-1 px-xl-2 cursor-pointer"
            :class="{'mt-1': index > 1}"
            :title="badge.name"
            @click="toggleInfoModal(badge)"
            data-bs-toggle="modal" data-bs-target="#infoModal"
        >
            <p class="mb-0">{{ badge.name }}</p>
        </span>
    </div>
</template>

<script>
    export default {
        props: ['tyre'],
        methods: {
            async toggleInfoModal(badge) {
                this.heading = badge.name + ' Tyres';
                this.text = '<p>' + badge.description + '</p>';
                this.emitter.emit('openInfoModal', {heading: badge.name + ' Tyres', text: '<p>' + badge.description + '</p>'});
            }
        },
        computed: {
            specialismBadges() {
                let badges = [];

                if(this.tyre?.electric == 1 || this.tyre?.electric_type) {
                    badges.push({name: 'EV/HEV', description: 'This tyre is suitable for electric/hybrid vehicles. Finding the perfect balance between low rolling resistance, high grip and sturdiness.'});
                }
                if(this.tyre?.season?.includes('All Season')) {
                    badges.push({name: 'All Season', description: 'All season tyres or all weather tyres have characteristics that make them suitable for use all year round.'});
                }
                if(_lowerCase(this.tyre.vehicle_type) == 'caravan') {
                    badges.push({name: 'Caravan', description: 'Caravan tyres are specially designed to support the extra weight of the vehicle and its contents. This capacity comes from the reinforced sidewall, making them more durable than the average tyre.'});
                }
                if(this.tyre?.rft == 1 && _lowerCase(this.tyre.rft_type) != 'ext') {
                    badges.push({name: 'RFT', description: 'Run flat tyres have been manufactured to be able to continue to perform safely, for a limited period, with no air pressure. If you suffer a puncture you will be able to safely drive to a garage in order to fix the problem.'});
                }
                if(_lowerCase(this.tyre?.rft_type) == 'ext') {
                    badges.push({name: 'EXT', description: 'Provides the functionality of a run flat technology. The tyre which has been developed in conjunction with Bridgestone and the vehicle manufacturer for use only with Mercedes vehicles.'});
                }
                else if(_lowerCase(this.tyre?.rft_type) == 'driveguard') {
                    badges.push({name: 'DG', description: 'The innovative Bridgestone DriveGuard technology allows you to maintain control after a puncture, and safely continue driving for 50 miles at up to 50 mph, until it\'s safe to either repair or replace your tyre.'});
                }
                else if(_lowerCase(this.tyre?.rft_type) == 'ssr' || (this.tyre?.ssr)) {
                    badges.push({name: 'SSR', description: 'Continental SSR (Self Supporting Runflat) tyres are compatible with all standard rims and allow you to drive for 50 miles at up to 50mph in the event of a puncture.'});
                }
                if(this.tyre?.season?.includes('Summer')) {
                    badges.push({name: 'Summer', description: 'Summer tyres offer optimal safety performance above +7 degrees celsius. The compounds used are meant to facilitate good handling and grip, on dry and wet roads alike.'});
                }
                if((this.tyre?.seal == 1 && _lowerCase(this.tyre?.brand) == 'continental') || this.tyre?.contiseal) {
                    badges.push({name: 'Seal', description: 'ContiSeal™️ tyres keep you moving by immediately sealing small punctures up to 5mm in diameter (such as a nail). This allows you to keep going and change the tyre at a more appropriate time.'});
                }
                if((this.tyre?.silent == 1 && _lowerCase(this.tyre?.brand) == 'continental') || this.tyre?.contisilent) {
                    badges.push({name: 'Silent', description: 'ContiSilent tyres reduce noise on all road surfaces and in all weather conditions. They offer no change to driving performance, mileage or load/speed capability. Mounting and storage are the same as standard tyres.'});
                }
                if((this.tyre?.silent == 1 && _lowerCase(this.tyre?.brand) == 'bridgestone')) {
                    badges.push({name: 'Silent', description: 'B-Silent technology quietens vehicle noise levels and road vibrations due to sound-absorbing foam fitted within the tyre.'});
                }
                if((this.tyre?.silent == 1 && _lowerCase(this.tyre?.brand) == 'dunlop')) {
                    badges.push({name: 'Silent', description: 'Noise Shield Technology sees a 50% reduction in interior noise levels that won’t compromise on performance potentialities.'});
                }
                if((this.tyre?.silent == 1 && _lowerCase(this.tyre?.brand) == 'goodyear')) {
                    badges.push({name: 'Silent', description: 'SoundComfortTechnology tyres reduce air vibrations and quieten interior noise within the vehicle to offer a smoother ride for you and passengers.'});
                }
                if((this.tyre?.silent == 1 && _lowerCase(this.tyre?.brand) == 'hankook')) {
                    badges.push({name: 'Silent', description: 'SoundAbsorber tyres reduce noise levels as much as 5 to 7 decibels. Achieve a pleasant ride with these high comfort tyres.'});
                }
                if((this.tyre?.silent == 1 && _lowerCase(this.tyre?.brand) == 'michelin')) {
                    badges.push({name: 'Silent', description: 'Acoustic Technology reduces road vibrations and interior noise by 20%, muffling noise resonance for a relaxed, quiet ride.'});
                }
                if((this.tyre?.silent == 1 && _lowerCase(this.tyre?.brand) == 'pirelli')) {
                    badges.push({name: 'Silent', description: 'PNCS is a noise-cancelling tyre that absorbs vibrations within the circumferential walls of the tyres by 2 to 3 decibels, significantly improving comfortability.'});
                }
                if(_lowerCase(this.tyre.vehicle_type) == 'trailer') {
                    badges.push({name: 'Trailer', description: 'Trailer tyres are designed with a strengthened sidewall making them suitable to be attached to a following vehicle. They tend to have a minimal tread to accommodate the movement of the trailer.'});
                }
                if(this.tyre.vehicle_type == 'Commercial Van') {
                    badges.push({name: 'Van', description: 'This tyre is suitable for use on vans. Our van tyres are specifically designed for this type of vehicle to cope with the extra weight and tough conditions.'});
                }
                if(this.tyre?.season?.includes('Winter')) {
                    badges.push({name: 'Winter', description: 'Winter tyres perform best in temperatures below 7°C. The rubber compound is specially designed to react better in colder temperatures which improves road grip. Some winter tyres have studs to help grip on snow and ice.'});
                }
                if(this.tyre?.xl == 'XL') {
                    badges.push({name: 'XL', description: 'XL stands for Extra Load. They use a more reinforced compound to carry heavier loads, but are the same size as normal tyres. If your car had XL tyres factory fitted then you must choose XL tyres for any new ones you buy.'});
                }
                if(this.tyre?.vehicle_type == 'Passenger 4x4') {
                    badges.push({name: '4x4', description: 'These types of cars require special tyres to ensure even tyre wear throughout the lifetime of the tyre and to be able to perform on off-road conditions.'});
                }
                if(this.tyre?.three_peaks == 1) {
                    badges.push({name: '3PMSF', description: '3PMSF winter tyres, bearing the 3 Peak Mountain Snow Flake symbol, signify their reliability and safety for driving in snowy conditions. The certification for the 3PMSF marking is granted by a recognised laboratory.'});
                }
                if(this.tyre?.ice_grip == 1) {
                    badges.push({name: 'M+S', description: 'M+S winter tyres are designed for mud and snow conditions. The M+S marking signifies enhanced performance on snowy or muddy roads compared to standard models, such as summer tyres. It\'s important to note that this designation is at the manufacturer\'s discretion and doesn\'t necessarily involve a certified test.'});
                }

                return badges;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '@frontendAssets/sass/_variables.scss';
    .specialisms {
        span {
            border-radius: 16px !important;
            padding: 6px !important;
            &:not(:last-of-type) {
                margin-right: 0.2rem !important;
            }
            p {
                font-size: 14px;
                color: #404040;
                font-weight: 300;
            }
        };
    }
</style>